import { observable } from 'mobx';
import { observer } from 'mobx-react';
import {
  DefaultButton,
  PrimaryButton,
} from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { localizable } from '../../../components/Localization';
import BlockDialog from './BlockDialog';

@localizable
@observer
class WhitelistingPanel extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
  };

  @observable isOpenBlockDialog = false;
  @observable selectedUserId;

  handleClose = () => {
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  };

  formattedDate = (date) => {
    return new Date(date).toFormatedDateString('L LT');
  };

  openBlockDialog = (userId) => {
    this.selectedUserId = userId;
    this.isOpenBlockDialog = true;
  };

  closeBlockDialog = () => {
    this.selectedUserId = undefined;
    this.isOpenBlockDialog = false;
  };

  handleAccept = async (userId) => {
    if (!userId) return;
    const { whitelisting } = this.props;
    await whitelisting.accept({ userId });
  };

  handleBlock = async ({ userId, reason }) => {
    if (!userId) return;
    const { whitelisting } = this.props;
    const ok = await whitelisting.block({ userId, reason });
    if (ok) {
      this.closeBlockDialog();
    }
  };

  render() {
    const { t, whitelisting } = this.props;

    return (
      <Panel
        headerText={t('Whitelisting')}
        type={PanelType.large}
        isOpen={this.props.isOpen}
        onDismissed={this.handleClose}
        onRenderFooterContent={this.renderPanelFooterContent}
        isFooterAtBottom={true}
        closeButtonAriaLabel={t('Close')}
      >
        {this.isOpenBlockDialog && (
          <BlockDialog
            isOpen={this.isOpenBlockDialog}
            onClose={this.closeBlockDialog}
            onSubmit={(reason) => {
              this.handleBlock({ userId: this.selectedUserId, reason });
            }}
          />
        )}
        <Fragment>
          <table style={{ width: '100%' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left' }}>{t('Agent')}</th>
                <th style={{ textAlign: 'left' }}>{t('Status')}</th>
                <th style={{ textAlign: 'left' }}>{t('Requested')}</th>
                <th style={{ textAlign: 'left' }}>{t('Action')}</th>
              </tr>
            </thead>
            <tbody>
              {whitelisting.whitelist.map((w) => {
                return (
                  <tr key={w.userId}>
                    <td>{getAgentName(w.data.agent)}</td>
                    <td>{t(w.status)}</td>
                    <td>{this.formattedDate(w.createdAt)}</td>
                    <td>
                      <PrimaryButton
                        text={t('accept')}
                        onClick={() => this.handleAccept(w.userId)}
                        allowDisabledFocus
                        disabled={w.status === 'whitelisted'}
                      />
                      <DefaultButton
                        text={t('block')}
                        onClick={() => this.openBlockDialog(w.userId)}
                        allowDisabledFocus
                        disabled={w.status === 'blocked'}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Fragment>
      </Panel>
    );
  }

  renderPanelFooterContent = () => {
    const { t } = this.props;
    return (
      <div className="ms-textAlignRight">
        <DefaultButton onClick={this.handleClose}>{t('Close')}</DefaultButton>
      </div>
    );
  };
}

function getAgentName(agent) {
  if (agent.name) {
    return agent.name;
  }
  if (agent.given_name && agent.family_name) {
    return `${agent.given_name} ${agent.family_name}`;
  }
  if (agent.email) {
    return agent.email;
  }
  if (agent.profile) {
    return getAgentName(agent.profile);
  }
}

export default WhitelistingPanel;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/WhitelistingSection/WhitelistingPanel.jsx